import { IDataContextProvider } from "@refinedev/core/dist/contexts/data/IDataContext";
import { AxiosInstance } from "axios";
import axAPI from "../../../api/axios-instance";
import { DataProvider } from "@refinedev/core";

export const pushSegmentsDataProvider = (
  apiUrl: string,
  httpClient: AxiosInstance = axAPI
): DataProvider =>
  <IDataContextProvider>{
    getApiUrl: () => apiUrl,
    custom: async ({ url, method, meta }) => {
      try {
        if (method?.toLowerCase() === "get") {
          const { data } = await httpClient.get(url, {
            params: meta?.params,
          });
          return { data };
        }
        return Promise.reject({ message: "Method not implemented" });
      } catch (e) {
        return Promise.reject(e);
      }
    },
    getList: async () => {
      const url = "cms/push/segments";
      try {
        const { data } = await httpClient.get(url);
        return {
          data,
        };
      } catch (e) {
        return Promise.reject(e);
      }
    },
    getOne: async () => {
      return Promise.reject({ message: "Method not implemented" });
    },
    update: async () => {
      return Promise.reject({ message: "Method not implemented" });
    },
    create: async ({ variables }) => {
      const url = "cms/push/segment/create";
      try {
        const { name } = variables as { name: string };
        const { data } = await httpClient.get(url, {
          params: { name },
        });
        return { data };
      } catch (error: any) {
        return Promise.reject(error);
      }
    },
    deleteOne: async () => {
      return Promise.reject({ message: "Method not implemented" });
    },
  };
